import { useSet } from 'ahooks';
import constate from 'constate';

export type ModalNames =
  | 'select-base-for-demo-modal'
  | 'create-new-demo-modal'
  | 'create-playbook-modal'
  | 'create-tour-modal'
  | 'diagnostic-check-modal'
  | 'restart-app-modal'
  | 'send-logs-modal'
  | 'app-version-modal'
  | 'version-download-modal'
  | 'app-settings-modal'
  | 'go-to-asset-modal'
  | 'new-folder-modal'
  | 'give-a-demo-modal'
  | 'manage-personas-modal'
  | 'add-new-persona-modal';

export const useModalContext = () => {
  const [set, { add, remove, reset }] = useSet<ModalNames>(new Set());

  const isModalOpen = (name: ModalNames): boolean => set.has(name);

  const closeModal = (name: ModalNames): void => remove(name);

  const closeAllModals = (): void => reset();

  const openModal = (name: ModalNames): void => add(name);

  const modalActionsByName = (name: ModalNames) => {
    return {
      closeModal: () => closeModal(name),
      openModal: () => openModal(name),
      isModalOpen: () => isModalOpen(name),
      name: name,
    };
  };

  return {
    closeAllModals,
    modalActionsByName,
    set,
  };
};

export const [ModalsProvider, useModalActions] = constate(useModalContext);
